function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "design/icon/media",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFFBED",
  cx: 27,
  cy: 27,
  r: 27
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(13.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#BE9C38",
  x: 0,
  y: 0,
  width: 28,
  height: 26,
  rx: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(0.832512, 1.793103)",
  fill: "#FFFBED"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0.0960591133,
  y: 0.0640394089,
  width: 2.78571429,
  height: 2.78571429,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 4.73891626,
  y: 0.0640394089,
  width: 2.78571429,
  height: 2.78571429,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 9.3817734,
  y: 0.0640394089,
  width: 2.78571429,
  height: 2.78571429,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 14.0246305,
  y: 0.0640394089,
  width: 2.78571429,
  height: 2.78571429,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 18.6674877,
  y: 0.0640394089,
  width: 2.78571429,
  height: 2.78571429,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 23.3103448,
  y: 0.0640394089,
  width: 2.78571429,
  height: 2.78571429,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0.0960591133,
  y: 19.5640394,
  width: 2.78571429,
  height: 2.78571429,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 4.73891626,
  y: 19.5640394,
  width: 2.78571429,
  height: 2.78571429,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 9.3817734,
  y: 19.5640394,
  width: 2.78571429,
  height: 2.78571429,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 14.0246305,
  y: 19.5640394,
  width: 2.78571429,
  height: 2.78571429,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 18.6674877,
  y: 19.5640394,
  width: 2.78571429,
  height: 2.78571429,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 23.3103448,
  y: 19.5640394,
  width: 2.78571429,
  height: 2.78571429,
  rx: 1
}))), /*#__PURE__*/React.createElement("circle", {
  className: "noscale",
  id: "Oval",
  fill: "#0C5860",
  cx: 27,
  cy: 27,
  r: 6
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4397932,23.9956176 C25.3294361,23.9396792 25.1930075,23.9387417 25.0819361,23.9946801 C24.9708647,24.0506184 24.9026504,24.153745 24.9026504,24.2656216 L24.9026504,28.6406874 C24.9026504,28.7528766 24.9708647,28.8560032 25.0819361,28.911629 C25.1369361,28.9394419 25.1983647,28.9531921 25.2597932,28.9531921 C25.3219361,28.9531921 25.3844361,28.9388169 25.4397932,28.9106915 L29.7255075,26.7231586 C29.8355075,26.6672203 29.9026504,26.5644062 29.9026504,26.4531545 C29.9026504,26.3422154 29.8355075,26.2394013 29.7255075,26.1831505 L25.4397932,23.9956176 Z",
  id: "filmstrip-path",
  fill: "#53A478"
})));

function SvgMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "design/icon/media") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.d5b67699.svg";
export { ForwardRef as ReactComponent };